import React, { useCallback, useEffect, useState } from "react";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
  changeRequestsReducer,
} from "./ChangeRequestsTable.store";
import CustomModal, {
  ModalSize,
} from "../../ui-library/CustomModal/CustomModal";
import ChangeRequestsTable from "../../library/ChangeRequestsTable/ChangeRequestsTable";
import ChangeRequest from "../ChangeRequest/ChangeRequest";

export const SmartChangeRequestsTable = (props) => {
  const {
    searchedParams,
    totalItems,
    changeRequests,
    fetchChangeRequests,
    canApproveChangeRequest,
    canViewDetailChangeRequest,
    resetState,
    studyId,
    loading,
  } = props;

  const [selectedChangeRequest, setSelectedChangeRequest] = useState(null);
  const [changeRequestModalTitle, setChangeRequestModalTitle] = useState("");

  const getData = useCallback(
    (params) => {
      fetchChangeRequests(params).catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
    },
    [fetchChangeRequests]
  );

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  useEffect(() => {
    if (totalItems === null) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalItems]);

  const onViewChangeRequest = (changeRequest) => {
    setSelectedChangeRequest({
      ...changeRequest,
      readOnly: true,
    });
  };

  const onApproveDeclineChangeRequest = (changeRequest) => {
    setSelectedChangeRequest({
      ...changeRequest,
      readOnly: false,
    });
  };

  const onCloseChangeRequestModal = (refresh) => {
    setChangeRequestModalTitle(null);
    setSelectedChangeRequest(null);

    if (refresh) {
      getData(searchedParams);
    }
  };

  return (
    <>
      <CustomModal
        show={selectedChangeRequest !== null}
        title={changeRequestModalTitle ?? ""}
        size={ModalSize.large}
        onClose={() => onCloseChangeRequestModal(false)}
      >
        <ChangeRequest
          participantId={selectedChangeRequest?.participantId}
          participantUsername={selectedChangeRequest?.ugnxId}
          onSubmit={onCloseChangeRequestModal}
          mealId={selectedChangeRequest?.mealId}
          changeRequest={selectedChangeRequest}
          setModalTitle={setChangeRequestModalTitle}
          readOnly={selectedChangeRequest?.readOnly}
          studyId={studyId}
        />
      </CustomModal>

      <ChangeRequestsTable
        {...{ getData }}
        {...{ searchedParams }}
        totalitems={totalItems}
        loading={loading}
        changeRequests={changeRequests}
        {...{ canApproveChangeRequest }}
        {...{ canViewDetailChangeRequest }}
        onApproveDecline={onApproveDeclineChangeRequest}
        onView={onViewChangeRequest}
      />
    </>
  );
};

export default dynamic(
  "changeRequestsReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(changeRequestsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartChangeRequestsTable));
